export default "__VITE_ASSET__btFhrPeT__"